function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 30",
  transform: "translate(-1095 -2929)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 24",
  cx: 40,
  cy: 40,
  r: 40,
  transform: "translate(1095 2929)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon ionic-md-people",
  d: "M1142.542 2966.786a5.614 5.614 0 005.657-5.536 5.658 5.658 0 00-11.313 0 5.614 5.614 0 005.656 5.536zm-15.084 0a5.614 5.614 0 005.652-5.535 5.658 5.658 0 00-11.313 0 5.614 5.614 0 005.662 5.535zm0 4.059c-4.431 0-13.2 2.122-13.2 6.458v4.982h26.668v-4.981c0-4.337-9.037-6.459-13.467-6.459zm15.084 1.015a10.1 10.1 0 00-1.616.092c2.169 1.569 2.963 2.583 2.963 5.351v4.982h11.852v-4.981c0-4.337-8.767-5.443-13.199-5.443z",
  fill: "#f9cec8"
}));
var SvgFamilies = function SvgFamilies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref);
};
export default SvgFamilies;